import { Loader2 } from "lucide-react";
import DiagnosticUiPanel from "@/components/sat/DiagnosticUiPanel";
import { useSatUiDiagnose } from "@/lib/useSatUiDiagnose";

/**
 * Aviso de cola quirúrgica SAT (Carril 1): XML faltantes descargándose con pausa anti-ráfaga.
 * `surgicalQueue` proviene de GET /sat/admin/storage-summary → surgical_queue.
 * Visible solo con sat_ui_diagnose_enabled (modo pruebas / web).
 */
export default function SurgicalQueueStatusBanner({ surgicalQueue, className = "" }) {
  const { enabled: diagnoseEnabled } = useSatUiDiagnose();
  const pending = Number(surgicalQueue?.pending) || 0;
  const processing = Number(surgicalQueue?.processing) || 0;
  const active = pending + processing;
  if (!diagnoseEnabled || active <= 0) return null;

  const restantes = pending > 0 ? pending : processing;

  return (
    <DiagnosticUiPanel enabled={diagnoseEnabled} badgePosition="top">
      <div
        className={`rounded-md border border-sky-200 bg-sky-50/90 px-3 py-2.5 flex items-start gap-2 text-sm text-sky-950 ${className}`}
        role="status"
        data-testid="surgical-queue-status-banner"
      >
        <Loader2 className="h-4 w-4 shrink-0 mt-0.5 animate-spin text-sky-700" aria-hidden />
        <p className="m-0 leading-relaxed">
          Descargando XMLs pendientes:{" "}
          <strong className="tabular-nums">{restantes.toLocaleString("es-MX")}</strong>{" "}
          {pending === 1 ? "restante" : "restantes"} de forma segura
          {processing > 0 && pending > 0 ? (
            <span className="text-sky-800/90">
              {" "}
              ({processing.toLocaleString("es-MX")} en curso ahora)
            </span>
          ) : null}
          . El sistema respeta una pausa entre cada comprobante para no saturar al SAT.
        </p>
      </div>
    </DiagnosticUiPanel>
  );
}
